/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import UserProfile from '@/screens/setting/users/components/UserProfile';

const ProfileScreen = (props) => {
  return <UserProfile {...props} />;
};

export default ProfileScreen;
